
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/localizacao",
      function () {
        return require("private-next-pages/localizacao.tsx");
      }
    ]);
  